// src/pages/ContactPage.js
import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useColorModeValue,
  AspectRatio,
  Divider,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm'; // <<< Reusing our existing component

export default function ContactPage() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <>
      <Header />
      <Box as="main" bg={bgColor}>
        <VStack spacing={0} align="stretch">
          {/* Page Header */}
          <VStack
            maxW="7xl"
            mx="auto"
            px={8}
            py={{ base: 16, md: 24 }}
            spacing={4}
            textAlign="center"
          >
            <Breadcrumb>
              <BreadcrumbItem>
                <BreadcrumbLink as={RouterLink} to="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">Contact Us</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Heading as="h1" size="2xl" fontWeight="extrabold">
              Get in Touch
            </Heading>
            <Text maxW="3xl" color="gray.600" fontSize="lg">
              We're here to answer your questions and help you get started on your next project. Reach out to us by phone, email, or through the form below.
            </Text>
          </VStack>

          {/* Reused Contact Form Section */}
          {/* Note: The ContactForm component brings its own padding and background */}
          <ContactForm />

          {/* New Map Section */}
          <VStack
            maxW="7xl"
            mx="auto"
            px={8}
            py={{ base: 16, md: 24 }}
            spacing={8}
            w="full"
          >
            <VStack spacing={4} textAlign="center">
              <Heading as="h2" size="xl">
                Our Location
              </Heading>
              <Text maxW="2xl" color="gray.600">
                Visit our office for a face-to-face consultation. We are conveniently located in Mesa, New Jersey.
              </Text>
            </VStack>
            <Box
              w="full"
              borderRadius="xl"
              boxShadow="xl"
              overflow="hidden"
              borderWidth="1px"
              borderColor={useColorModeValue('gray.200', 'gray.700')}
            >
              <AspectRatio ratio={16 / 9}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2918.0327398257823!2d39.26600872876616!3d8.546948400000012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b1f7ca1bdfee5%3A0xcb82ee3567e0bdc5!2sG7W9%2BQX%2C%20Nazret!5e1!3m2!1sen!2set!4v1759142048121!5m2!1sen!2set"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </AspectRatio>
            </Box>
          </VStack>
        </VStack>
      </Box>
      <Footer />
    </>
  );
}